module.exports = __webpack_public_path__ + "static/transformation-b21c946af46909cdc1b64fd2c03b15eb.png";